((Drupal) => {
  Drupal.behaviors.nrwfChoices = {
    attach: (context) => {

      once('nrwf-choices', '.form-select', context).forEach(($element) => {
        // const element = document.querySelector('.js-choice');
        const $hasSearch = $element.getAttribute('data-has-search') ?? false;
        const choices = new Choices($element, {
          itemSelectText: '',
          searchEnabled: $hasSearch,
          shouldSort: false,
          noResultsText: Drupal.t('No results found'),
          fuseOptions: {
            threshold: 0.1,
            distance: 1000
          }
        });
      });

      once('nrwf-choices-all', '.choices__list--dropdown .choices__item[data-value="All"]').forEach(($element) => {
        $element.textContent = 'Alle';
      });

    },
  };
})(Drupal);
